/**
 * Returns true when the given organization has NOT granted Support Access, i.e. jumping in is
 * blocked for super admins without the bypass permission. Returns false when the organization is
 * unknown (`undefined`), so callers can pass the result of a lookup directly.
 */
export function isOrganizationSupportAccessRevoked(organization) {
    return organization !== undefined && !organization.support_access_granted_at;
}
